import React from "react"
import { Link } from "gatsby"
import tw from "twin.macro"
import rehypeRaw from "rehype-raw"

import ReactMarkdown from "react-markdown"
import { Article, Author } from "../model/cms"
import { Image } from "./Image"

const ArticleOuterContainer = tw.div`w-full border-b-2`
const ArticleContainer = tw.div`max-w-3xl mx-auto py-10`
const ArticlePublishDate = tw.p`text-sm text-gray-600 mb-2`
const ArticleTitle = tw.h2`text-3xl font-semibold mb-4`
const ArticleBigTitle = tw.h1`text-6xl font-semibold mb-4 font-display`
const ArticleProse = tw.div`prose max-w-full mb-6`
const AuthorContainer = tw.div`flex flex-row w-full items-center`
const AuthorAvatar = tw.div`w-10 h-10 flex rounded-full overflow-hidden`
const AuthorNameAndTitle = tw.div`flex flex-col ml-2`
const AuthorName = tw.p``
const AuthorTitle = tw.p`text-sm text-gray-600`


interface AuthorAndCategoryProps {
    author: Author
}

function AuthorInfo({ author }: AuthorAndCategoryProps) {
    return (
        <AuthorContainer>
            <AuthorAvatar>
                <Image alt={author.name}
                    image={author.avatar.localFile}
                />
            </AuthorAvatar>
            <AuthorNameAndTitle>
                <AuthorName>{author.name} </AuthorName>
                <AuthorTitle> {author.title} </AuthorTitle>
            </AuthorNameAndTitle>
        </AuthorContainer>
    )
}

interface ArticleViewProps {
    article: Article
    singleArticle?: boolean
}

export function ArticleView({ article, singleArticle }: ArticleViewProps) {
    const articleUrl = `/articles/${article.slug}`

    const published = new Date(article.createdAt)
        .toLocaleDateString("en-gb", {
            year: "numeric",
            month: "long",
            day: "numeric",
            timeZone: "utc"
        })

    const title = singleArticle
        ? (
            <ArticleBigTitle>{article.title}</ArticleBigTitle>
        ) : (
            <ArticleTitle>
                <Link to={articleUrl}>
                    {article.title}
                </Link>
            </ArticleTitle>
        )

    let content;

    if (singleArticle) {
        content = (
            <ReactMarkdown skipHtml={true} rehypePlugins={[rehypeRaw]}>{article.content}</ReactMarkdown>
        )
    } else {
        content = (
            <div>
                <ReactMarkdown skipHtml={true} rehypePlugins={[rehypeRaw]}>{article.excerpt}</ReactMarkdown>
                <Link to={articleUrl}>Continue reading...</Link>
            </div>
        )
    }

    return (
        <ArticleOuterContainer>
            <ArticleContainer>
                <ArticlePublishDate>{published} </ArticlePublishDate>
                {title}
                <ArticleProse>
                    {content}
                </ArticleProse>
                {
                    article.author &&
                    <AuthorInfo author={article.author}
                    />
                }
            </ArticleContainer>
        </ArticleOuterContainer>
    )
}
